/**
 * Utilitas tagging massal untuk kontak baru pada grup tertentu.
 * Memakai endpoint kontak dan CRM yang sudah tersedia di aplikasi.
 */

function normalisasiDaftarGrup(groupIds) {
  return (Array.isArray(groupIds) ? groupIds : [])
    .map(grup => {
      if (grup && typeof grup === "object") {
        return grup.id !== undefined ? { id: grup.id } : null;
      }

      return grup !== "" && grup !== null && grup !== undefined
        ? { id: grup }
        : null;
    })
    .filter(Boolean);
}

function unikkanBerdasarkanId(rows) {
  const map = {};

  (Array.isArray(rows) ? rows : []).forEach(row => {
    if (row && row.id !== undefined && row.id !== null) {
      map[String(row.id)] = row;
    }
  });

  return Object.keys(map).map(key => map[key]);
}

export async function ambilKontakGrup(store, groupIds, options) {
  const daftarGrup = normalisasiDaftarGrup(groupIds);

  if (!daftarGrup.length) {
    return [];
  }

  const perPage =
    options && Number(options.perPage) > 0 ? Number(options.perPage) : 500;
  const maksimal =
    options && Number(options.maxContacts) > 0
      ? Number(options.maxContacts)
      : 5000;

  let offset = 0;
  let hasil = [];
  let totalRecords = 0;
  let putaran = 0;

  while (putaran < 20) {
    const response = await store.dispatch("contact/getContactList", {
      keywords: "",
      phone_number: "",
      email: "",
      name: "",
      group_id: daftarGrup,
      page: offset,
      perPage: perPage
    });

    const rows = response && Array.isArray(response.data) ? response.data : [];
    totalRecords = Number(response && response.totalRecords) || 0;

    hasil = hasil.concat(
      rows.filter(row => {
        return row && row.is_group != 1;
      })
    );

    if (
      !rows.length ||
      rows.length < perPage ||
      (totalRecords > 0 && hasil.length >= totalRecords) ||
      hasil.length >= maksimal
    ) {
      break;
    }

    offset += perPage;
    putaran += 1;
  }

  return unikkanBerdasarkanId(hasil).slice(0, maksimal);
}

export async function terapkanTagKeKontakBaru(store, options) {
  const groupIds = (options && options.groupIds) || [];
  const tagIds = ((options && options.tagIds) || []).filter(idTag => {
    return idTag !== "" && idTag !== null && idTag !== undefined;
  });
  const baselineIds = (options && options.baselineIds) || [];
  const percobaan =
    options && Number(options.attempts) > 0 ? Number(options.attempts) : 4;
  const jeda =
    options && Number(options.delay) >= 0 ? Number(options.delay) : 1200;

  if (!groupIds.length || !tagIds.length) {
    return {
      ok: true,
      count: 0,
      gagal: 0,
      message: ""
    };
  }

  const baseline = {};
  baselineIds.forEach(id => {
    baseline[String(id)] = true;
  });

  let kontakBaru = [];

  try {
    for (let putaran = 0; putaran < percobaan; putaran += 1) {
      const kontakGrup = await ambilKontakGrup(store, groupIds);
      kontakBaru = kontakGrup.filter(kontak => {
        return !baseline[String(kontak.id)];
      });

      if (kontakBaru.length) {
        break;
      }

      if (putaran < percobaan - 1 && jeda > 0) {
        await new Promise(resolve => setTimeout(resolve, jeda));
      }
    }
  } catch (error) {
    return {
      ok: false,
      count: 0,
      gagal: 0,
      message:
        "Gagal memeriksa kontak baru untuk tagging. Silakan atur tagging dari daftar Kontak."
    };
  }

  if (!kontakBaru.length) {
    return {
      ok: false,
      count: 0,
      gagal: 0,
      message:
        "Kontak baru belum tersedia saat tagging akan diterapkan. Silakan atur tagging dari daftar Kontak setelah proses selesai."
    };
  }

  let berhasil = 0;
  let gagal = 0;
  const ukuranBatch = 8;

  for (let index = 0; index < kontakBaru.length; index += ukuranBatch) {
    const batch = kontakBaru.slice(index, index + ukuranBatch);
    const hasilBatch = await Promise.all(
      batch.map(kontak => {
        return store
          .dispatch("crm/assignContactToTag", {
            id: kontak.id,
            tag_id: tagIds
          })
          .then(() => true)
          .catch(() => false);
      })
    );

    hasilBatch.forEach(sukses => {
      if (sukses) {
        berhasil += 1;
      } else {
        gagal += 1;
      }
    });
  }

  if (berhasil === 0) {
    return {
      ok: false,
      count: 0,
      gagal: gagal,
      message:
        "Tagging massal belum berhasil diterapkan. Silakan atur tagging dari daftar Kontak."
    };
  }

  return {
    ok: true,
    count: berhasil,
    gagal: gagal,
    message:
      gagal > 0
        ? "Tagging diterapkan ke " +
          berhasil +
          " kontak baru. Sebagian kontak belum berhasil ditandai."
        : "Tagging diterapkan ke " + berhasil + " kontak baru."
  };
}



// WEBPACK FOOTER //
// ./src/utils/contactTagging.js